import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import Loading from 'components/Loading';

const VideoModal = ({ show, source, toggleModal, isCommentVideo }) => {
  const [remuxVideoAvailable, setRemuxVideoAvailable] = useState(false);
  const retry = useRef(0);

  // In future we can add browser checks to avoid this logic
  // for browsers that don't need it, like firefox.
  if (isCommentVideo && !remuxVideoAvailable) {
    const sourceMetaUrl = source.replace('alt=media', '');
    let intervalID = null;

    // eslint-disable-next-line no-inner-declarations
    function loadRemuxUrl() {
      retry.current += 1;
      if (retry.current > 10) {
        setRemuxVideoAvailable(true);
        clearInterval(intervalID);
        return;
      }
      fetch(sourceMetaUrl)
        .then((res) => res.json())
        .then((data) => {
          const timeCreated = new Date(data.timeCreated);

          // If remux is done or more than 10mins has elapsed
          // since object creation (because we don't want to wait
          // for remuxing every time the resource is loaded - even after
          // say 10 days)
          if (
            data?.metadata?.remux === 'done' ||
            Date.now() - timeCreated > 600000
          ) {
            setRemuxVideoAvailable(true);
            clearInterval(intervalID);
          }
        });
    }
    loadRemuxUrl();
    intervalID = setInterval(loadRemuxUrl, 6000);
  }

  const videoEl = (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      style={{ width: '100%' }}
      autoPlay
      controls
      src={source}
      controlsList="nodownload"
    />
  );

  return (
    <Modal
      show={show}
      toggleModal={toggleModal}
      contentProps={{
        style: {
          maxWidth: 860,
          padding: 40,
        },
      }}
      closeButtonProps={{
        style: {
          top: 10,
          right: 10,
        },
      }}>
      <div className="video-recorder">
        {remuxVideoAvailable ? videoEl : <Loading height="auto" />}
      </div>
    </Modal>
  );
};

VideoModal.propTypes = {
  show: PropTypes.bool.isRequired,
  source: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isCommentVideo: PropTypes.bool,
};

export default VideoModal;
